/**
 * Remembered workspace (tenant) slug. The BFF's hosted-login entry point
 * requires tenantSlug — tenant admins live in per-tenant Keycloak realms — but
 * a bare email like gmail.com can't identify the workspace. So the slug is
 * remembered here at every point we learn it (signup, SSO resolution, an
 * authenticated session) and prefills the login form on return visits.
 */
const WORKSPACE_KEY = 'fa-workspace-slug'

export function rememberWorkspaceSlug(slug: string | null | undefined): void {
  if (!slug) return
  try {
    localStorage.setItem(WORKSPACE_KEY, slug)
  } catch {
    // Private mode / blocked storage — the login form just won't prefill.
  }
}

export function rememberedWorkspaceSlug(): string {
  try {
    return localStorage.getItem(WORKSPACE_KEY) ?? ''
  } catch {
    return ''
  }
}
